export const PRODUCT_ITEM_TYPES = {
  PRODUCT: 'product',
  SERVICE: 'service',
};
